"use client";

import React from "react";
import { cn } from "@/utils/cn";
import useCMS from "@/utils/hooks/useCMS";

export type LogoKey =
  | "KLIK_LOGO"
  | "KLIK_LOGO_WHITE"
  | "ENEWS_LOGO"
  | "ENEWS_LOGO_WHITE"
  | "CORE_LOGO"
  | "CORE_LOGO_WHITE"
  | "MAIN_LOGO"
  | "SECONDARY_LOGO"
  | "SIMPLE_LOGO"
  | "LOGO"
  | "FOOTER_LOGO"
  | "FAVICON";

type Props = React.ImgHTMLAttributes<HTMLImageElement> & {
  logo?: LogoKey;
  fallback: string;
};

/**
 * Renders a logo from the CMS, falling back to the bundled asset.
 *
 * Size it with `max-h` and `max-w` rather than width/height: Tailwind's preflight
 * forces `height: auto` on images, so a fixed width turns a square upload into
 * a logo as tall as it is wide. Bounding both sides lets the browser keep the
 * ratio whatever shape ends up in the CMS.
 */
function BrandLogo({ logo = "KLIK_LOGO", fallback, alt = "", className, ...props }: Props) {
  const { cmsData: logos } = useCMS("LOGOS");

  return (
    <img
      src={logos?.[logo]?.cdnUrl ?? fallback}
      alt={alt}
      className={cn("w-auto max-w-full object-contain", className)}
      {...props}
    />
  );
}

export default BrandLogo;
